import 'whatwg-fetch';

class NewsletterModule {
    constructor() {
        this.initialize();
    }

    initialize() {
        this.bindUI();
        this.bindEvents();
    }

    bindUI() {
        this.ui = {};

        this.ui.$form = document.querySelector('.js-form-newsletter');
        this.ui.$modal = document.querySelector('.js-form-modal');
        this.ui.$modalClose = this.ui.$modal.querySelector('.js-form-modal-close');
        this.ui.$modalContent = this.ui.$modal.querySelector('.js-form-modal-content');
    }

    bindEvents() {
        this.ui.$modalClose.addEventListener('click', this.hideModal.bind(this));
        this.ui.$form.addEventListener('submit', this.onSubmit.bind(this));
    }

    onSubmit(e) {
        e.preventDefault();

        const formData = new FormData(this.ui.$form);

        fetch(this.ui.$form.getAttribute('action'), {
            method: 'POST',
            body: formData
        })
        .then((res) => {
            return res.text();
        })
        .then((text) => {
            this.showModal();
            this.fillModal(text);
            this.emptyForm();
        });

    }

    showModal() {
        this.ui.$modal.classList.add('is-visible');
    }

    hideModal(e) {
        e.preventDefault();

        this.ui.$modal.classList.remove('is-visible');
    }

    fillModal(content) {
        this.ui.$modalContent.innerHTML = content;
    }

    emptyForm() {
        this.ui.$form.reset();
    }
}

export default NewsletterModule;
